import { configure } from "@cervval.js/client-html5-spa";
import { importBootstrap5 } from "@cervval.js/client-html5-ui/src/lookAndFeel/bootstrap5";
import { importFontAwesome6 } from "@cervval.js/client-html5-ui/src/lookAndFeel/fontAwesome6";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { buildDefaultErrorMessageService } from "@cervval.js/common/src/services/errorMessage.impl/default.errorMessage.service";
import { getNavigationServiceConfiguration } from "@zurvan-terminal/client-shared/src/pages/login/login.navigation";
import { LoginClientMainService } from "@zurvan-terminal/client-shared/src/services/loginClientMainService.service";
import "../../../assets/global.dom.scss"; // *.dom.scss files are injected in html by style-loader

importFontAwesome6();
importBootstrap5();

registerServices();

// Configure the single page application
configure({
    configureNavigation: getNavigationServiceConfiguration()
});

/**
 * Register services
 */
function registerServices(): void {
    injector.register(new LoginClientMainService());
    injector.register(buildDefaultErrorMessageService());
}